module.exports = __webpack_public_path__ + "img/recart-3.315fb4f8.jpg";